import { put, select, takeLatest } from 'redux-saga/effects';
import { get } from 'lodash';
import { PAGES } from '../../utils/pages';
import { getReport } from '../actions/report';
import { filterIds } from '../../utils/filters';
import { type RootState } from '../types';

export function* doGenerateReport(): Generator<any, void, any> {
    const reportFilters = yield select((state: RootState) => get(state, 'filters'));
    if (reportFilters[filterIds.reportTypeFilter] && reportFilters[filterIds.reportViewFilter]?.value) {
        yield put(getReport());
    }
}

export function* onReportLoad(): Generator<any, void, any> {
    yield takeLatest(PAGES.REPORTS, doGenerateReport);
}

export const reportLoadHandler = [onReportLoad()];
